"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.engineAspiration = void 0;
exports.getEngineAspirationName = getEngineAspirationName;
const lodash_1 = __importDefault(require("lodash"));
function getEngineAspirationName(val) {
    const d = lodash_1.default.find(exports.engineAspiration, { type: val });
    return lodash_1.default.get(d, 'name') || '';
}
exports.engineAspiration = [
    {
        id: 'N/A',
        type: 'N/A',
        value: 'N/A',
        name: 'Naturally Aspirated',
        regex: /^natural*/i
    },
    {
        id: 'T',
        type: 'T',
        value: 'T',
        name: 'Turbo',
        regex: /^turbo/i
    },
    {
        id: 'TT',
        type: 'TT',
        value: 'TT',
        name: 'Twin Turbo',
        regex: /twin.*turbo/i
    },
    {
        id: 'TW',
        type: 'TW',
        value: 'TW',
        name: 'Twincharged',
        regex: /twin.*charged/i
    },
    {
        id: 'SC',
        type: 'SC',
        value: 'SC',
        name: 'Supercharged',
        regex: /super.*changed/i
    },
    {
        id: 'QT',
        type: 'QT',
        value: 'QT',
        name: 'Quad Turbo',
        regex: /quad.*turbo/i
    }
];
